import cls from 'classnames';

const styles = {
  heading: 'text-h4 text-red-light mb-2 teair:text-air-mediumBlue',
  text: 'text-overline text-gray-2 mb-8 md:mb-6 teair:text-air-skyBlue',
  formGroup: 'md:flex items-start',
  link: 'underline teair:text-air-mediumBlue',
  inputWrapper: 'mb-4 md:mr-4',
  input: (hasValue: boolean) => cls(hasValue && 'border-gray-2'),
  button: `w-full mb-6 py-3`,
  checkboxGroup: 'flex flex-row gap-3 items-start',
  checkbox: cls(
    'mt-0.5 w-5 h-5 shrink-0 rounded-[0.25rem] bg-black-light border border-gray-2 cursor-pointer',
    'focus:outline-none focus:ring-1 focus:ring-gray-2 focus:ring-offset-0',
    'disabled:cursor-not-allowed disabled:opacity-50',
    'checked:bg-red-medium checked:border-red-medium',
  ),
  checkboxLabel:
    'inline-block text-body2 text-white cursor-pointer select-none teair:text-air-mediumBlue',
  checkboxLink: 'underline text-red-medium hover:text-red',
  errorText: 'text-red-medium text-small mt-1',
  btnContainer: 'text-center md:text-left',
  cancelBtn: 'text-body2 text-gray-2 underline teair:text-air-mediumBlue',
};

export default styles;
